module.exports = "<cat-modal-content\n  [title]=\"title\"\n  [controls]=\"controls\"\n>\n  <cat-panel-list\n    title=\"Project Feature Units\"\n    [items]=\"featureUnitLinkItems\"\n  ></cat-panel-list>\n</cat-modal-content>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/feature/feature.component.html
// module id = ../../../../../src/app/modules/project-details/components/feature/feature.component.html
// module chunks = main